/**
 * Prototype UI — replace with Medplum hooks later.
 */

export type RemittanceMatchStatus = 'matched' | 'partial' | 'unmatched';
export type RemittancePostingStatus = 'posted' | 'pending' | 'exception';

export interface RemittanceRow {
  id: string;
  payer: string;
  receivedAt: string;
  paymentMethod: 'EFT' | 'Check';
  checkOrEftNumber: string;
  totalPaid: number;
  claimCount: number;
  matchStatus: RemittanceMatchStatus;
  postingStatus: RemittancePostingStatus;
  eobIds: string[];
}

export const MOCK_REMITTANCES: RemittanceRow[] = [];

export function findRemittanceById(id: string | undefined): RemittanceRow | undefined {
  if (!id) return undefined;
  return MOCK_REMITTANCES.find((r) => r.id === id);
}
